if (!customElements.get('brand-logos-mobile')) {
  class BrandLogosMobile extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.brand-logos__items-mobile',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
        swiperSlide: 'swiper-slide',
      };

      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.sliderInstance = false;
      this.init();
    }

    init() {
      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Mousewheel],
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: this.querySelector(this.selectors.nextEl),
          prevEl: this.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        loop: false,
        threshold: 2,
        autoHeight: true,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
      }
    }
  }
  customElements.define('brand-logos-mobile', BrandLogosMobile);
}
